(function () {
  "use strict";

  // ----------------------------------------------------------------------------------------------------------------
  // PDP CART-UI FALLBACK
  // ----------------------------------------------------------------------------------------------------------------
  //
  // On product pages, add-to-cart normally opens Gokwik's own sidecart, which is the intended
  // cart UI here — this script does not fight that. It only exists as a safety net: if Gokwik's
  // sidecart hasn't appeared within a few seconds of a real add-to-cart (network hiccup, Gokwik
  // script not ready yet, cold page load still starting up other scripts, etc.), it forces the
  // native drawer open as a last resort so a shopper never ends up with no cart feedback at all.
  // If Gokwik does show up — even if it takes a while on a cold load — nothing happens; this polls
  // instead of checking once early specifically so it doesn't steal the open from Gokwik while
  // it's still mid-render.
  //
  // The add-to-cart request gets intercepted by bundle-cart-sync.liquid's patched fetch/XHR before
  // the theme's own ProductForm.onSubmit_fn ever runs, so the theme's native cart:change
  // ("baseEvent":"variant:add") never actually fires for this flow — only bundle-cart-sync's own
  // "cart:refresh" event does.
  //
  // BUG FIX: "cart:refresh" is not exclusively an add-to-cart signal — other scripts dispatch it
  // for background cart housekeeping unrelated to anything the shopper did on this page (observed:
  // an untargeted /cart/update.js call on plain page load, with no line-item change at all, still
  // triggered this fallback and popped the native drawer open with nothing added). Gating on a
  // recent click on this page's own add-to-cart button ties the fallback back to actual shopper
  // intent, so a background refresh can no longer open cart UI nobody asked for.

  var isProductPage = document.body.classList.contains("template-product");
  if (!isProductPage) return;

  var POLL_INTERVAL_MS = 200;
  var FALLBACK_TIMEOUT_MS = 4000;

  var recentAddClick = false;
  var recentAddClickTimer = null;

  document.addEventListener("click", function (event) {
    var button = event.target.closest('button[type="submit"]');
    if (!button) return;
    var form = button.closest("form");
    if (!form || !form.hasAttribute("data-atc-source")) return;
    recentAddClick = true;
    clearTimeout(recentAddClickTimer);
    recentAddClickTimer = setTimeout(function () { recentAddClick = false; }, 2500);
  }, true);

  function getShadowRoot() {
    var container = document.querySelector("shadow-dom-container");
    return container ? container.shadowRoot : null;
  }

  function sidecartMounted() {
    var sr = getShadowRoot();
    return sr ? !!sr.querySelector(".sidecart") : false;
  }

  function openNativeDrawer() {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer || typeof drawer.show !== "function") return;
    if (drawer.hasAttribute("open")) return;
    if (window.__zkCartGate && typeof window.__zkCartGate.forceRelease === "function") {
      window.__zkCartGate.forceRelease();
    }
    drawer.show();
  }

  function armFallbackWatch() {
    var elapsed = 0;
    var pollId = setInterval(function () {
      elapsed += POLL_INTERVAL_MS;
      if (sidecartMounted()) {
        clearInterval(pollId);
        return;
      }
      if (elapsed >= FALLBACK_TIMEOUT_MS) {
        clearInterval(pollId);
        openNativeDrawer();
      }
    }, POLL_INTERVAL_MS);
  }

  document.addEventListener("cart:change", function (event) {
    if (!event.detail || event.detail.baseEvent !== "variant:add") return;
    armFallbackWatch();
  });

  document.addEventListener("cart:refresh", function () {
    if (!recentAddClick) return;
    armFallbackWatch();
  });
})();
